export default {
    props: {
        current_page: {
            type: Number,
            default: 0,
        },
        next_page: {
            type: Number,
            default: 0,
        },
        last_page: {
            type: Number,
            default: 0,
        },
        scroll_top: {
            type: Boolean,
            default: false,
        }
    },
    data(){
        return {
            callData: '',
            goPage: '',
        }
    },
    created() {
        let attrs = this.$attrs;
        if(typeof(attrs.callData) != 'function'){
            console.error('attr callData is a function');
        }else{
            this.callData = attrs.callData;
        }
    },
    methods: {
        async callDataFunction(page){
            await this.callData(page);
            if(this.scroll_top){
                window.scrollTo(0, 0)
            }
        },
        callGoLink(){
            if(isNaN(this.goPage) || this.goPage % 1 != 0){
                this.goPage = '';
            }else{
                if(this.goPage < 1){
                    this.goPage = 1;
                }else if(this.goPage > this.last_page){
                    this.goPage = this.last_page
                }
                this.callDataFunction(this.goPage)
            }
        }
    },
    render(h){
        var page = [];
        var goPage = '';
        if(this.last_page <= 5){
            for(let i = 1; i <= this.last_page; i++){
                if(i == this.current_page){
                    page.push(<li class="page-item active"><div class="page-link">{i}</div></li>)
                }else{
                    page.push(<li class="page-item" onClick={() => this.callDataFunction(i)}><div class="page-link">{i}</div></li>)
                }
            }
        }else{
            if(this.$detect == 'web'){
                let i = 0, last_i = 0;
                let pushLastPage = true;
                if(this.current_page <= 4){
                    i = 1;
                    last_i = 5;
                }else if(this.last_page - this.current_page <= 4){
                    i = this.last_page - 5;
                    last_i = this.last_page;
                    pushLastPage = false;
                }else{
                    i = this.current_page - 2;
                    last_i = this.current_page + 2;
                }
                for(let i1 = i; i1 <= last_i; i1++){
                    if(i1 == this.current_page){
                        page.push(<li class="page-item active"><div class="page-link">{i1}</div></li>)
                    }else{
                        page.push(<li class="page-item" onClick={() => this.callDataFunction(i1)}><div class="page-link">{i1}</div></li>)
                    }
                }
                if(pushLastPage){
                    page.push(<li class="page-item"><div class="page-link page-between">...</div></li>)
                    page.push(<li class="page-item" onClick={() => this.callDataFunction(this.last_page)}><div class="page-link">{this.last_page}</div></li>)
                }
            }
            var widthInput = 40;
            var placeholder = 'Trang';
            let widthWindow = window.screen.width;
            if(widthWindow > 320 && this.$detect == 'mobile'){
                widthInput = 40;
            }else if(this.$detect == 'web'){
                widthInput = 70;
                placeholder = 'Tới trang'
            }
            goPage = (
                <li class="page-item">
                    <div class="page-link p-1 go-page">
                        <input type="text" placeholder={placeholder} class="border-0"
                            onClick={(e) => e.target.select()}
                            v-model={this.goPage}
                            onChange={() => this.callGoLink()}
                            style={'width: ' + widthInput + 'px'}/>
                        <span class="ml-1">/ {this.last_page}</span>
                    </div>
                </li>
            )
        }
        var classPagination = this.$detect == 'web' ? 'pagination-vatgia' : 'pagination-vatgia pagination-vatgia-mobile';
        var pageCus = this.$detect == 'web' ? ('') : (
            <li class="page-item">
                <div class="page-link prev-page text-body" aria-label="Previous">
                    Trang {this.current_page}
                </div>
            </li>
        )
        return (
            <nav class={classPagination}>
                
                <ul class="pagination justify-content-end">
                    {pageCus}
                    {
                        this.last_page > 5 && this.current_page > 2 && window.screen.width > 320 ? (
                            <li class="page-item" onClick={() => this.callDataFunction(1)}>
                                <div class="page-link prev-page" aria-label="Previous">
                                    <span aria-hidden="true">&laquo;</span>
                                </div>
                            </li>
                        ) : ('')
                    }
                    {
                        this.current_page > 1 ? (
                            <li class="page-item"><div class="page-link" onClick={() => this.callDataFunction(this.current_page - 1)}>Previous</div></li>
                        ) : ('')
                    }
                    
                    {page}

                    {
                        this.current_page != this.last_page ? (
                            <li class="page-item" onClick={() => this.callDataFunction(this.current_page + 1)}><div class="page-link">Next</div></li>
                        ) : ('')
                    }
                    
                    {
                        this.last_page > 5 && (this.last_page - this.current_page > 2) && window.screen.width > 320 ? (
                            <li class="page-item" onClick={() => this.callDataFunction(this.last_page)}>
                                <div class="page-link next-page" aria-label="Next">
                                    <span aria-hidden="true">&raquo;</span>
                                </div>
                            </li>
                        ) : ('')
                    }
                    {goPage}
                </ul>
            </nav>
        )
    }
}